import request from "@/utils/request";
// 接受消息开关店铺列表
export function GetShopList(params) {
  return request({
    url: "/h5/setting/getShopList",
    method: "post",
    params,
  });
}
// 接受消息开关店铺列表
export function SetRemindSwitch(params) {
  return request({
    url: "/h5/setting/SetRemindSwitch",
    method: "post",
    params,
  });
}